import Vue from "vue";
import Router from "vue-router";
const webIndexTwo = resolve => require(["../views/index"], resolve); // 主页
const productsTwo = resolve =>
  require(["../views/products"], resolve); // 产品中心
const productDetail = resolve =>
  require(["../views/product/productDetail"], resolve); // 产品详情
const solutionsTwo = resolve =>
  require(["../views/solutions"], resolve); // 解决方案
const solutionDetail = resolve =>
  require(["../views/solution/solutionDetail"], resolve); // 解决方案详情
const newsTwo = resolve => require(["../views/news/news"], resolve); // 超级资讯模块
const newsDatailsTwo = resolve =>
  require(["../views/news/newDetails"], resolve); // 超级资讯详情模块
const AboutTwo = resolve => require(["../views/about/about"], resolve); // 关于我们模块

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "index",
      component: webIndexTwo
    },
    {
      path: "/products",
      name: "products",
      component: productsTwo
    },
    {
      path: "/product/:id",
      name: "productDetail",
      component: productDetail
    },
    {
      path: "/solutions",
      name: "solutions",
      component: solutionsTwo
    },
    {
      path: "/solution/:id",
      name: "solutionDetail",
      component: solutionDetail
    },
    {
      path: "/NewsTwo",
      name: "NewsTwo",
      component: newsTwo
    },
    {
      path: "/newsDatailsTwo",
      name: "newsDatailsTwo",
      component: newsDatailsTwo
    },
    {
      path: "/AboutTwo",
      name: "AboutTwo",
      component: AboutTwo
    },
    {
      path: "*",
      redirect: "/"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  },
  mode: "history"
});



// WEBPACK FOOTER //
// ./src/router/index.js